'use client';

import { useLayoutEffect, useState } from 'react';

export default function usePageLoaded() {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  useLayoutEffect(() => {
    const onPageLoad = () => {
      setIsPageLoaded(true);
    };

    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad, false);

      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  return isPageLoaded;
}
